import actions from 'actions';
import {connect} from "react-redux";
import SurveyComponent from "../Components/SurveyComponent/SurveyComponent";
import {createApolloClient} from "Helpers/ApolloClientHelpers";

const mapStateToProps = (state) => {
  return {
    user:state.current && state.current.user,
    client:createApolloClient()
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConditions:(aSearchString, aLimit, aOffset) => {
      return dispatch(actions.getConditions(aSearchString, aLimit, aOffset));
    },
    fetchMedicationsWithCountryCode:(aQuery, aMedCountryCode, aLimit, aOffset) => {
      return dispatch(actions.fetchMedicationsWithCountryCode(aQuery, aMedCountryCode, aLimit, aOffset));
    },
    getMedraConditions:(aLimit, aOffset, aSearchString) => {
      return dispatch(actions.getMedraConditions(aLimit, aOffset, aSearchString));
    },
    updateSurveyResponseLockState:(aSurveyResponseId, aLockedState, aIsTestResponse = false) => {
      return dispatch(actions.updateSurveyResponseLockState(aSurveyResponseId, aLockedState, aIsTestResponse));
    },
    respondToSurvey:(aSurveyId, aSurveyResponseId, aAnswers, aUserId, aAdminId, aClient, aIsTestResponse, aStayOnCurrentPage) => {
      return dispatch(actions.respondToSurvey(aSurveyId, aSurveyResponseId, aAnswers, aUserId, aAdminId, aClient, aIsTestResponse, aStayOnCurrentPage));
    },
    questionBeforeKey:(aSurveyResponseDetailId, aSurveyId, aQuestionKey, aUserId, aGetQuestionAfter, aSurveyResponseId, aIsTestResponse = false) => {
      return dispatch(actions.questionBeforeKey(aSurveyResponseDetailId, aSurveyId, aQuestionKey, aUserId, aGetQuestionAfter, aSurveyResponseId, aIsTestResponse));
    },
    getDynamicListItems:(aDynamicListId, aLimit, aOffset, aSearchString) => {
      return dispatch(actions.getDynamicListItems(aDynamicListId, aLimit, aOffset, aSearchString));
    },
    firstSurvey:(aSurveyId, aUserId, aSurveyResponseId, aIsTestResponse = false) => {
      return dispatch(actions.firstSurvey(aSurveyId, aUserId, aSurveyResponseId, aIsTestResponse));
    },
    loopableSurveyResponse:(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false, aChildSurveyResponseId = null, aIndex = null) => {
      return dispatch(actions.loopableSurveyResponse(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse, aChildSurveyResponseId, aIndex));
    },
    loopableSurveyResponses:(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false, aLimit = 10, aOffset = 0) => {
      return dispatch(actions.loopableSurveyResponses(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse, aLimit, aOffset));
    },
    createLoopableSurveyResponse:(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false) => {
      return dispatch(actions.createLoopableSurveyResponse(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse));
    },
    deleteLoopableSurveyResponse:(aPatientId, aSurveyResponseId, aChildSurveyResponseId = null, aIsTestResponse = false, aLoopReference = null, aIndex = null) => {
      return dispatch(actions.deleteLoopableSurveyResponse(aPatientId, aSurveyResponseId, aChildSurveyResponseId, aIsTestResponse, aLoopReference, aIndex));
    },
    createDataQueryNote:(aPatientId, aDescription, aSurveyResponseDetailId, aNotificationAlert) => {
      return dispatch(actions.createDataQueryNote(aPatientId, aDescription, aSurveyResponseDetailId, aNotificationAlert));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyComponent);
